import { render, staticRenderFns } from "./addBox.vue?vue&type=template&id=dc576d6a&scoped=true&"
import script from "./addBox.vue?vue&type=script&lang=js&"
export * from "./addBox.vue?vue&type=script&lang=js&"
import style0 from "./addBox.vue?vue&type=style&index=0&id=dc576d6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc576d6a",
  null
  
)

export default component.exports